import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { WkCompareService } from '../../services/wk-compare.service';
import {
  OpenCompareAndMergeDialogAction,
  OPEN_COMPARE_AND_MERGE_DIALOG,
} from '../actions/app.custom-actions';

@Injectable()
export class CompareEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly compareService: WkCompareService
  ) {}

  openCompareAndMergeDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<OpenCompareAndMergeDialogAction>(OPEN_COMPARE_AND_MERGE_DIALOG),
        map(() => {
          this.compareService.openCompareAndMergeDialog();
        })
      ),
    { dispatch: false }
  );
}
